"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13.287 5.958a1 1 0 00-.574-1.916l-10 3c-.95.285-.95 1.631 0 1.916l10 3a1 1 0 00.574-1.916L6.48 8l6.807-2.042z"];
//# sourceMappingURL=less-than.js.map